<!-- 行信息 -->
<template>
  <div>
    <vxe-toolbar v-if="canEdit">
      <template v-slot:buttons>
        <vxe-button
          @click="handleDelete('detailDataList')"
          type="primary"
          size="medium"
          icon="el-icon-delete"
          class="vxe-btn-delete"
          >删除行</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-grid
      border
      show-overflow
      resizable
      ref="detailDataList"
      class="vxe-table-element"
      size="mini"
      align="left"
      pre
      :auto-resize="true"
      :columns="detailListColumn"
      :data="detailDataList"
      :edit-rules="detailRules"
      :edit-config="{
        trigger: 'click',
        mode: 'row',
        activeMethod: activeRowMethod,
      }"
    >
    </vxe-grid>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  // import API from '@/api/wareHouse/costAdjustOrder';
  // import InputNumberAd from '@/components/form-item/input-number-advance';
  export default {
    components: {
      // InputNumberAd,
    },
    props: ['detailDataList', 'canEdit', 'validate'],
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      // 库存行信息
      detailListColumn() {
        return [
          { type: 'checkbox', width: 50 }, // checkbox
          {
            field: 'sortNo',
            title: this.$t('costAdjustOrderList.column.sortNo'),
            visible: true,
            width: '80',
          },
          {
            field: 'storageDepartmentCode',
            title: this.$t('costAdjustOrderList.column.storageDepartmentCode'),
            visible: true,
            width: 120,
          }, //仓库编码
          {
            field: 'storageDepartmentName',
            title: this.$t('costAdjustOrderList.column.storageDepartmentName'),
            visible: true,
            width: 120,
          }, //仓库名称
          {
            field: 'batchNo',
            title: this.$t('costAdjustOrderList.column.batchNo'),
            visible: true,
            width: 120,
          }, //批次号
          {
            field: 'productNo',
            title: this.$t('costAdjustOrderList.column.productNo'),
            visible: true,
            width: 120,
          }, //物料编码
          {
            field: 'productName',
            title: this.$t('costAdjustOrderList.column.productName'),
            visible: true,
            width: 120,
          }, //物料描述
          {
            field: 'productUnit',
            title: this.$t('costAdjustOrderList.column.productUnit'),
            visible: true,
            width: 120,
          }, //单位
          {
            field: 'storageQuantity',
            title: this.$t('costAdjustOrderList.column.storageQuantity'),
            visible: true,
            width: 120,
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.storageQuantity,
                      this.$globalVar.qPoint
                    )}
                  </span>,
                ];
              },
            },
          }, //库存数量
          {
            field: 'storagePrice',
            title: this.$t('costAdjustOrderList.column.storagePrice'),
            visible: true,
            width: 120,
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(row.storagePrice, this.$globalVar.pPoint)}
                  </span>,
                ];
              },
            },
          }, //库存单价
          {
            field: 'storageAmount',
            title: this.$t('costAdjustOrderList.column.storageAmount'),
            visible: true,
            width: 120,
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(row.storageAmount, this.$globalVar.aPoint)}
                  </span>,
                ];
              },
            },
          }, //库存金额
          {
            field: 'mainBusinessCost',
            title: this.$t('costAdjustOrderList.column.mainBusinessCost'),
            visible: true,
            width: 120,
            slots: {
              default: ({ row }) => {
                return [
                  <span>
                    {this.$baseRequest.formatTableColumn(
                      row.mainBusinessCost,
                      this.$globalVar.aPoint
                    )}
                  </span>,
                ];
              },
            },
          }, //已发货成本
          {
            field: 'currencyName',
            title: this.$t('costAdjustOrderList.column.currencyName'),
            visible: true,
            width: 120,
          }, //币种
          {
            field: 'adjustStorageAmount',
            title: this.$t('costAdjustOrderList.column.adjustStorageAmount'),
            visible: true,
            width: 160,
            ...{
              editRender: {
                name: 'ElInput',
                props: {
                  clearable: true,
                },
              },
              slots: {
                default: ({ row }) => {
                  return [
                    <span>
                      {this.$baseRequest.formatTableColumn(
                        row.adjustStorageAmount,
                        this.$globalVar.aPoint
                      )}
                    </span>,
                  ];
                },
                edit: ({ row }) => {
                  return [
                    <input-number-ad
                      value={row.adjustStorageAmount}
                      required={true}
                      min={-99999999999999999}
                      max={99999999999999999}
                      precision={this.$globalVar.aPoint}
                      onInput={(val) => this.chooseSearchTable(row, val, 'adjustStorageAmount')}
                    ></input-number-ad>,
                  ];
                },
              },
            },
          }, //业务库存调整金额
          {
            field: 'adjustMainBusinessCost',
            title: this.$t('costAdjustOrderList.column.adjustMainBusinessCost'),
            visible: true,
            width: 160,
            ...{
              slots: {
                default: ({ row }) => {
                  return [
                    <span>
                      {this.$baseRequest.formatTableColumn(
                        row.adjustMainBusinessCost,
                        this.$globalVar.aPoint
                      )}
                    </span>,
                  ];
                },
              },
            },
          }, //已发货成本调整金额
        ];
      },
      detailRules() {
        // const validRules =  {
        return {
          adjustStorageAmount: [
            {
              required: true,
              message: '请输入' + this.$t('costAdjustOrderList.column.adjustStorageAmount'),
            },
          ],
        };
      },
    },
    mounted() {
      //
    },
    watch: {
      // 判断表格编辑功能是否禁用
      canEdit: function (newQuestion) {
        this.editConfig = newQuestion ? { trigger: 'click', mode: 'row' } : {};
      },
    },
    data() {
      return {};
    },
    methods: {
      // 初始化数据
      initData() {
        console.log(this.detailDataList);
      },
      activeRowMethod() {
        //禁用编辑
        return this.canEdit;
      },
      // 表格删除
      handleDelete(tableName) {
        const selectedList = this.$refs[tableName].getSelectRecords(); // 获取选中数据
        if (this.$refs[tableName].getTableData().fullData.length > 1) {
          if (selectedList.length < 1) {
            this.$message({
              showClose: true,
              message: this.$t('xTable.noSelectData'),
              type: 'error',
            });
            return;
          } else {
            this.$confirmAction()
              .then(() => {
                this.$message({
                  showClose: true,
                  type: 'success',
                  message: this.$t('receivablesManage.message.deleteSuccess'),
                });
                this.$refs[tableName].removeSelecteds();
                // this.detailDataList = this.$refs[tableName].getTableData().fullData;
              })
              .catch(() => {
                /* this.$message({
              showClose: true,
              type: "info",
              message: this.$t('receivablesManage.message.cancelled')
            }); */
              });
          }
        } else {
          this.$message({
            showClose: true,
            message: this.$t('当前成本调整单仅剩一条数据不可删除！'),
            type: 'error',
          });
          return;
        }
      },
      chooseSearchTable(row, val, type) {
        row[type] = val;
        row['adjustMainBusinessCost'] = -this.$cal.calCommon(1, row['adjustStorageAmount'], '*');
      },
      handleSubmit() {
        return new Promise((resolve) => {
          this.$refs.detailDataList.validate((valid) => {
            if (valid) resolve();
          });
        });
      },
    },
  };
</script>
